import { createScriptTag } from '@/third-party/helpers'
import { type App, inject } from 'vue'

const key = 'app.plugin.fouanalytics.enabled'
export type FouanalyticsConfig = {
    enabled: boolean
}

export function installFouanalyticsConfig(
    app: App,
    config: FouanalyticsConfig
): void {
    app.provide(key, config)
}

export function useFouanalyticsConfig(): FouanalyticsConfig {
    return inject(key) as FouanalyticsConfig
}

export function importFouanalytics(document: Document): void {
    createScriptTag(
        document,
        'https://eu.b2c.com/api/init-2047n3vgscwb6i1yph4n.js'
    )
}
